import axios from "axios"

import { apiDomain } from "../../store/constants"

const MainProject = {
    getMainProjects (data) {
        return axios({
            url: apiDomain + `api/main-project`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getMainProjectById (id) {
        return axios({
            url: apiDomain + `api/main-project/get-plan/` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getMasterMainProject () {
        return axios({
            url: apiDomain + `api/main-project/create`,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    storeMainProject (data) {
        return axios({
            url: apiDomain + `api/main-project`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getMainProjectsByUSP (data) {
        return axios({
            url: apiDomain + `api/project-accept-round`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default MainProject